module.exports = __webpack_public_path__ + "static/media/banner-210909_2.b759133f.png";